/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ListingMyDesignersQueryVariables = Types.Exact<{
    page?: Types.Maybe<Types.Scalars['Int']>;
    pageSize?: Types.Maybe<Types.Scalars['Int']>;
}>;

export type ListingMyDesignersQuery = {
    __typename: 'Query';
    myDesigners: {
        __typename: 'MyDesignersResponse';
        totalPages: number;
        totalResults: number;
        designers: Array<{
            __typename: 'DesignerSummary';
            userCanonicalId: string;
            isAvailable: boolean;
            user: Types.Maybe<{
                __typename: 'User';
                displayName: string;
                profile: { __typename: 'Profile'; avatarUrl: string };
            }>;
            collaborations: Array<{
                __typename: 'DesignerCollaborationSummary';
                publicId: string;
                title: string;
                state: Types.CollaborationState;
            }>;
        }>;
    };
};

export const ListingMyDesignersDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ListingMyDesigners' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myDesigners' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pageSize' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pageSize' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designers' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userCanonicalId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isAvailable' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'user' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'displayName',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'profile',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'avatarUrl',
                                                                        },
                                                                        arguments: [
                                                                            {
                                                                                kind: 'Argument',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'size',
                                                                                },
                                                                                value: {
                                                                                    kind: 'EnumValue',
                                                                                    value: 'S',
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'collaborations' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'publicId',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'title' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'state' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalResults' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useListingMyDesignersQuery__
 *
 * To run a query within a React component, call `useListingMyDesignersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingMyDesignersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingMyDesignersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useListingMyDesignersQuery(
    baseOptions?: Apollo.QueryHookOptions<ListingMyDesignersQuery, ListingMyDesignersQueryVariables>
) {
    return Apollo.useQuery<ListingMyDesignersQuery, ListingMyDesignersQueryVariables>(
        ListingMyDesignersDocument,
        baseOptions
    );
}
export function useListingMyDesignersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ListingMyDesignersQuery,
        ListingMyDesignersQueryVariables
    >
) {
    return Apollo.useLazyQuery<ListingMyDesignersQuery, ListingMyDesignersQueryVariables>(
        ListingMyDesignersDocument,
        baseOptions
    );
}
export type ListingMyDesignersQueryHookResult = ReturnType<typeof useListingMyDesignersQuery>;
export type ListingMyDesignersLazyQueryHookResult = ReturnType<
    typeof useListingMyDesignersLazyQuery
>;
export type ListingMyDesignersQueryResult = Apollo.QueryResult<
    ListingMyDesignersQuery,
    ListingMyDesignersQueryVariables
>;
